module.exports = __webpack_public_path__ + "static/potted_plants_flip-7f5c53ce1720399552885cba1731d7ac.png";